export const trimProtocol = (raw: string) => {
  if (!raw) return ''
  return raw.replace(/^https?:/g, '')
}

const webp = (function () {
  try {
    return document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') == 0
  } catch (err) {
    return false
  }
})()

export const bfsImage = (u: string | undefined, w?: number, h?: number, c?: boolean) => {
  if (!u || typeof w !== 'number' || typeof h !== 'number') {
    return u
  }
  let url = trimProtocol(u)
  const suffix = url.match(/(.*\.(jpg|jpeg|gif|png|bmp))(\?.*)?/)
  // 路径是否包含/bfs/
  const isBfs = url.indexOf('/bfs/') !== -1 ? true : false
  // 是否是GIF图片
  if (!suffix || suffix[2] === 'gif' || suffix[2] === 'bmp' || !isBfs) {
    return url
  }

  const dpr = window.devicePixelRatio || 1

  // 裁剪规则
  const cut = w && h ? '@' + Math.round(w * dpr) + 'w_' + Math.round(h * dpr) + 'h' + `${c ? '_1c_1s' : ''}` : '@'
  // 图片后参数 比如视频动态图
  const arg = suffix[3] ? suffix[3] : ''
  if (webp) {
    return suffix[1] + cut + '.webp' + arg
  } else {
    return suffix[1] + cut + '.' + suffix[2] + arg
  }
}
